var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorSkinOther(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error_skin_other") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error_skin_other",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#F03F3F",
    transform: "translate(50.000000, 50.000000) rotate(-270.000000) translate(-50.000000, -50.000000) ",
    x: 19,
    y: 2.5,
    width: 62,
    height: 95,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    strokeOpacity: 0.552502185,
    stroke: "#FFFFFF",
    fill: "#F03F3F",
    transform: "translate(50.500000, 50.000000) rotate(-270.000000) translate(-50.500000, -50.000000) ",
    x: 33,
    y: 32.5,
    width: 35,
    height: 35,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.876,57 L81.904,40.984 L81.904,31 L74.208,31 L74.208,40.984 L76.184,57 L79.876,57 Z M82.164,68.128 L82.164,60.12 L74,60.12 L74,68.128 L82.164,68.128 Z",
    id: "!",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSkinOther);
export default __webpack_public_path__ + "static/media/error_skin_other.13669aa30a5374a08c9c78d5951f50aa.svg";
export { ForwardRef as ReactComponent };